import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'

const bitcoinPalette = {
  ColorPaletteBitcoinLight: '#00D4FF',
  ColorPaletteBitcoinDark: '#00D4FF',
  ColorPaletteBitcoinActive: '#00BDE6',
  ColorPaletteBitcoinHover: '#00C5F0',
  ColorPaletteBitcoinBackgroundTransparent: '#00C5F019', // 10% Opacity
  ColorPaletteBitcoinBackground: '#00C5F0',
  ColorPaletteBitcoinDisabled: '#FFFFFF',
} as const

export const bitcoinArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  textBrand: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  buttonProminentBackgroundDefault: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  buttonProminentBackgroundDisabled: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  buttonProminentBackgroundHover: {
    light: bitcoinPalette.ColorPaletteBitcoinHover,
    dark: bitcoinPalette.ColorPaletteBitcoinHover,
  },
  buttonSubtleBackgroundHover: {
    light: 'transparent',
    dark: 'transparent',
  },
}

const bitcoinColors = {
  active: {
    light: bitcoinPalette.ColorPaletteBitcoinActive,
    dark: bitcoinPalette.ColorPaletteBitcoinActive,
  },
  link: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinLight,
  },
  primaryButtonActive: {
    light: bitcoinPalette.ColorPaletteBitcoinActive,
    dark: bitcoinPalette.ColorPaletteBitcoinActive,
  },
  primaryButtonHover: {
    light: bitcoinPalette.ColorPaletteBitcoinHover,
    dark: bitcoinPalette.ColorPaletteBitcoinHover,
  },
  primary: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  primaryButtonBackground: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  tint: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  progressBarFill: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  disabled: {
    light: bitcoinPalette.ColorPaletteBitcoinDisabled,
    dark: bitcoinPalette.ColorPaletteBitcoinDisabled,
  },
  outlineButtonSelectedBorder: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  inputFocusBorder: {
    light: bitcoinPalette.ColorPaletteBitcoinLight,
    dark: bitcoinPalette.ColorPaletteBitcoinDark,
  },
  navigationItemActiveText: {
    light: bitcoinPalette.ColorPaletteBitcoinBackground,
    dark: bitcoinPalette.ColorPaletteBitcoinBackground,
  },
  navigationItemActiveBackground: {
    light: bitcoinPalette.ColorPaletteBitcoinBackgroundTransparent,
    dark: bitcoinPalette.ColorPaletteBitcoinBackgroundTransparent,
  },
} as ThemeColorsOverride

export default bitcoinColors
